/* eslint-disable import/prefer-default-export */
const regex = /\${[^{]+}/g;
const priceFormat = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
});

export function formatPrice(value: number) {
  return priceFormat.format(value);
}

export function currencyParts(amount: number) : string[] {
  const money = amount.toFixed(2).toString();
  return money.split('.');
}

export function interpolate(template: string, variables: any) {
  return template.replace(regex, (match) => {
    const key = match.slice(2, -1).trim();
    return variables[key] || '';
  });
}